import React, { FC, ReactElement } from 'react';

import css from './style.module.scss';

interface IProps {
  children: ReactElement | ReactElement[];
}

const ArticleBlock: FC<IProps> = ({ children }) => {
  return <div className={css.articleBlock}>{children}</div>;
};

export default ArticleBlock;
